import { Button, Form, Input, Modal } from "antd";
import { useEffect } from "react";
import {
  IProductionProjectMember,
  IUpdateProductionProjectMember,
} from "../../models/Production";
import { useUpdateProductionProjectMember } from "../../query/ProductionQuery";
import { notify } from "../../utils/toast";

interface IModalEditProductionMemberProps {
  open: boolean;
  onCancel: () => void;
  member: IProductionProjectMember | null;
}

const ModalEditProductionMember = ({
  open,
  onCancel,
  member,
}: IModalEditProductionMemberProps) => {
  const [form] = Form.useForm();
  const updateMemberMutation = useUpdateProductionProjectMember();

  useEffect(() => {
    if (member && open) {
      form.setFieldsValue({
        fullName: member.fullName,
        role: member.role,
        phone: member.phone,
      });
    }
  }, [member, open, form]);

  const handleSubmit = async () => {
    if (!member) return;

    try {
      const values = await form.validateFields();
      const data: IUpdateProductionProjectMember = {
        fullName: values.fullName,
        role: values.role,
        phone: values.phone,
      };

      await updateMemberMutation.mutateAsync({ id: member.id, data: data });
      notify.success("Cập nhật thành viên thành công");
      onCancel();
      form.resetFields();
    } catch (error) {
      notify.error("Cập nhật thành viên thất bại");
    }
  };

  return (
    <Modal
      title="Chỉnh sửa thành viên dự án"
      open={open}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onCancel();
            form.resetFields();
          }}
        >
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={updateMemberMutation.isPending}
        >
          Cập nhật
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Họ và tên"
          name="fullName"
          rules={[{ required: true, message: "Vui lòng nhập họ và tên" }]}
        >
          <Input placeholder="Nhập họ và tên" />
        </Form.Item>

        <Form.Item
          label="Vai trò"
          name="role"
          rules={[{ required: true, message: "Vui lòng nhập vai trò" }]}
        >
          <Input placeholder="Nhập vai trò (VD: Project Manager, Developer...)" />
        </Form.Item>

        <Form.Item
          label="Số điện thoại"
          name="phone"
          rules={[
            { required: true, message: "Vui lòng nhập số điện thoại" },
            {
              pattern: /^[0-9]{10,11}$/,
              message: "Số điện thoại không hợp lệ",
            },
          ]}
        >
          <Input placeholder="Nhập số điện thoại" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditProductionMember;
